var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contents-inner" },
    [
      !_vm.isLightPlan
        ? [
            _vm.companyInfo.catchCopy
              ? _c(
                  "p",
                  { staticClass: "fwB", attrs: { "data-test": "catch" } },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.companyInfo.catchCopy) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "taC mt15", attrs: { "data-test": "introImage" } },
              [
                _vm.companyInfo.introImage && _vm.companyInfo.introImage.id
                  ? _c("img", {
                      staticClass: "company-img-main image-height-auto",
                      attrs: {
                        src: _vm.getPhotoUrl(_vm.companyInfo.introImage),
                      },
                    })
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _vm.companyInfo.introText
              ? _c("p", {
                  staticClass: "mt15 pega-pre-wrap",
                  attrs: { "data-test": "introText" },
                  domProps: { textContent: _vm._s(_vm.companyInfo.introText) },
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.companyInfo.name
        ? _c("p", { staticClass: "mt20", attrs: { "data-test": "name" } }, [
            _vm._v("\n    " + _vm._s(_vm.companyInfo.name) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm.companyInfo.businessContent
        ? _c("p", {
            staticClass: "mt20 pega-pre-wrap",
            attrs: { "data-test": "businessContent" },
            domProps: { textContent: _vm._s(_vm.companyInfo.businessContent) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.companyInfo.established
        ? [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "mt20", attrs: { "data-test": "established" } },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.companyInfo.established) + "\n    "
                ),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.companyInfo.capital
        ? [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "mt20", attrs: { "data-test": "capital" } },
              [_vm._v("\n      " + _vm._s(_vm.companyInfo.capital) + "\n    ")]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.companyInfo.sale
        ? [
            _vm._m(4),
            _vm._v(" "),
            _c("p", { staticClass: "mt20", attrs: { "data-test": "sale" } }, [
              _vm._v("\n      " + _vm._s(_vm.companyInfo.sale) + "\n    "),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isShow.employee
        ? [
            _vm._m(5),
            _vm._v(" "),
            _vm.companyInfo.employeeNumber
              ? _c(
                  "p",
                  {
                    staticClass: "mt20",
                    attrs: { "data-test": "employeeNumber" },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.companyInfo.employeeNumber) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.companyInfo.averageAge
              ? _c(
                  "dl",
                  {
                    staticClass: "bg-blue-box mt15",
                    attrs: { "data-test": "averageAge" },
                  },
                  [
                    _c("dt", [_vm._v("平均年齢")]),
                    _vm._v(" "),
                    _c("dd", [_vm._v(_vm._s(_vm.companyInfo.averageAge))]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.companyInfo.midCareerPercentage
              ? _c(
                  "dl",
                  {
                    staticClass: "bg-blue-box mt10",
                    attrs: { "data-test": "midCareerPercentage" },
                  },
                  [
                    _c("dt", [_vm._v("中途入社の割合")]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.companyInfo.midCareerPercentage)),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isShow.representative
        ? [
            _vm._m(6),
            _vm._v(" "),
            _vm.companyInfo.representative
              ? _c(
                  "p",
                  {
                    staticClass: "mt20",
                    attrs: { "data-test": "representative" },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.companyInfo.representative) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.companyInfo.representativeProfile
              ? _c(
                  "dl",
                  {
                    staticClass: "bg-blue-box mt15",
                    attrs: { "data-test": "representativeProfile" },
                  },
                  [
                    _c("dt", [_vm._v("代表者略歴")]),
                    _vm._v(" "),
                    _c("dd", {
                      staticClass: "pega-pre-wrap",
                      domProps: {
                        textContent: _vm._s(
                          _vm.companyInfo.representativeProfile
                        ),
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.companyInfo.note
        ? [
            _vm._m(7),
            _vm._v(" "),
            _c("p", {
              staticClass: "mt20 pega-pre-wrap",
              attrs: { "data-test": "note" },
              domProps: { textContent: _vm._s(_vm.companyInfo.note) },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.companyInfo.hp
        ? [
            _vm._m(8),
            _vm._v(" "),
            _c("p", { staticClass: "mt20", attrs: { "data-test": "hp" } }, [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.companyInfo.hp,
                    target: "_blank",
                    rel: "nofollow",
                  },
                },
                [_vm._v(_vm._s(_vm.companyInfo.hp))]
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLightPlan
        ? [
            _vm._l([1, 2, 3], function (index) {
              return [
                _vm.companyInfo["companyImage" + index + "Caption"]
                  ? _c(
                      "div",
                      {
                        key: index,
                        staticClass: "remarks-block",
                        class: [{ mt20: index === 1 }, { mt10: index !== 1 }],
                        style:
                          "background: url(" +
                          _vm.userCommonImageUrlForSp +
                          "/bg_stripe_gray.png) repeat top left;",
                        attrs: { "data-test": "companyImage-" + index },
                      },
                      [
                        _vm.companyInfo["companyImage" + index].id
                          ? _c("img", {
                              staticClass: "company-img-sub image-height-auto",
                              attrs: {
                                src: _vm.getPhotoUrl(
                                  _vm.companyInfo["companyImage" + index]
                                ),
                                "data-test": "image-" + index,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.companyInfo[
                                "companyImage" + index + "Caption"
                              ]
                            )
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "name-title" } },
      [_c("span", [_vm._v("会社名")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "hd-type-0n3",
        attrs: { "data-test": "businessContent-title" },
      },
      [_c("span", [_vm._v("事業内容")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "hd-type-0n3",
        attrs: { "data-test": "established-title" },
      },
      [_c("span", [_vm._v("設立")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "capital-title" } },
      [_c("span", [_vm._v("資本金")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "sale-title" } },
      [_c("span", [_vm._v("売上高")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "hd-type-0n3",
        attrs: { "data-test": "employeeNumber-title" },
      },
      [_c("span", [_vm._v("従業員数")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "hd-type-0n3",
        attrs: { "data-test": "representative-title" },
      },
      [_c("span", [_vm._v("代表者")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "note-title" } },
      [_c("span", [_vm._v("備考")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "hp-title" } },
      [_c("span", [_vm._v("企業HP")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }